export const approvals = {
  en: {
    title: "Approvals",
    subtitle: "Review and respond to approval requests",
    all: "All",
    client: "Client",
    teammate: "Teammate",
    allCaughtUp: "All caught up!",
    noApprovals: "You don't have any approval requests awaiting your response.",
    noApprovalsFiltered: "approval requests awaiting your response.",
    clientApproval: "Client Approval",
    teamApproval: "Team Approval",
    awaitingResponse: "Awaiting Response",
    requestedBy: "Requested by",
    due: "Due",
    overdue: "(Overdue)",
    addNotes: "Add optional notes with your response...",
    reject: "Reject",
    approve: "Approve",
    processing: "Processing...",
    loadingApprovals: "Loading approvals",
    noPendingApprovals: "No pending approvals",
    responseNotesFor: "Response notes for",
    rejectApprovalFor: "Reject approval for",
    approveLabel: "Approve",
  },
  es: {
    title: "Aprobaciones",
    subtitle: "Revisa y responde a solicitudes de aprobación",
    all: "Todas",
    client: "Cliente",
    teammate: "Compañero",
    allCaughtUp: "¡Todo al día!",
    noApprovals: "No tienes solicitudes de aprobación pendientes.",
    noApprovalsFiltered: "solicitudes de aprobación pendientes.",
    clientApproval: "Aprobación de Cliente",
    teamApproval: "Aprobación de Equipo",
    awaitingResponse: "Esperando Respuesta",
    requestedBy: "Solicitado por",
    due: "Vence",
    overdue: "(Vencido)",
    addNotes: "Agrega notas opcionales con tu respuesta...",
    reject: "Rechazar",
    approve: "Aprobar",
    processing: "Procesando...",
    loadingApprovals: "Cargando aprobaciones",
    noPendingApprovals: "Sin aprobaciones pendientes",
    responseNotesFor: "Notas de respuesta para",
    rejectApprovalFor: "Rechazar aprobación de",
    approveLabel: "Aprobar",
  },
};
